module.exports = __webpack_public_path__ + "840c81a94f64c03c2629f6069fd65f60.jpg";


//////////////////
// WEBPACK FOOTER
// ./assets/social/speakers/carolyn-stransky.jpg
// module id = 507
// module chunks = 0